import { motion } from "framer-motion";
import { PROCESS_STEPS } from "@/data/content";

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="border-b border-[#E4E7EC] bg-[#101828] text-white"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="overline mb-4 text-[#FDB022]">§ 02 — Operating protocol</p>
            <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight text-white sm:text-5xl md:text-6xl">
              Four steps. Zero surprises.
            </h2>
          </div>
          <p className="max-w-md text-base leading-relaxed text-[#98A2B3]">
            A repeatable, documented workflow that your ops team can plug into.
            Every shipment moves through these four gates — and you get a
            WhatsApp/email update at each one.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-0 border border-[#1F2937] md:grid-cols-4">
          {PROCESS_STEPS.map((s, i) => (
            <motion.div
              key={s.step}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`relative p-6 md:p-8 ${
                i < PROCESS_STEPS.length - 1
                  ? "border-b border-[#1F2937] md:border-b-0 md:border-r"
                  : ""
              }`}
              data-testid={`process-step-${s.step}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-mono-accent text-[#FDB022]">STEP {s.step}</span>
                <span className="font-display text-4xl font-black leading-none text-[#1F2937]">
                  0{i + 1}
                </span>
              </div>
              <h3 className="mt-6 font-display text-xl font-bold leading-tight tracking-tight text-white">
                {s.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#98A2B3]">
                {s.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
